import { ComponentRef, Injectable, ViewContainerRef } from '@angular/core';
import { Subject, BehaviorSubject } from 'rxjs';
import { NotificationsService } from 'angular2-notifications';
import { NotificationStatus } from '../../shared/common';
import { NotificationToast } from '../../shared/model/notification-toast';
import { NotificationsToastComponent } from '../../shared/component/notifications-toast/notifications-toast.component';
import { Constants } from 'src/app/core/common';
import { NotificationsSidebarService } from './notifications-sidebar-service';

@Injectable({
  providedIn: 'root',
})
export class NotificationToastService {
  // private fields
  private notificationStatus = new Subject<NotificationStatus>();
  private notificationContent = new BehaviorSubject<NotificationToast>(null);
  private openNotificationsCenter = new BehaviorSubject<boolean>(false);

  // public fields
  public notificationStatus$ = this.notificationStatus.asObservable();
  public notificationContent$ = this.notificationContent.asObservable();
  public openNotificationsCenter$ = this.openNotificationsCenter.asObservable();
  public notificationsConfig = {
    timeOut: Constants.NOTIFICATION_CONFIG_TIME,
    showProgressBar: true,
    pauseOnHover: true,
    clickToClose: true,
  };
  private componentRef!: ComponentRef<NotificationsToastComponent>;
  constructor(
    private _notifications: NotificationsService,  
    private notificationsSidebarService: NotificationsSidebarService
  ) {}


  public getNotifications(notification: NotificationToast , entry: ViewContainerRef): void {
    this.componentRef = entry.createComponent(NotificationsToastComponent);
    this.componentRef.instance.notification = notification;
    const toast = this._notifications.html(this.componentRef.instance.customSnackBar, notification.NotificationType , this.notificationsConfig);
    toast.click.subscribe(click=>{
      this.notificationsSidebarService.openSideNavBar()
    })
  }

  public SnackBar(notification: NotificationToast , entry: ViewContainerRef): void {
    this.getNotifications(notification , entry)
  }
}
